import * as t from 'io-ts';

export enum StudyOptionValidatorAction {
  error = 'in case A operator B is TRUE - show failure_message and prevent submitting the answer',
  warning = 'in case A operator B is TRUE - show failure_message but allow submitting the answer'
}
export const studyOptionValidatorActionSchema = t.keyof(StudyOptionValidatorAction);
export type StudyOptionValidatorActionType = t.TypeOf<typeof studyOptionValidatorActionSchema>;
